import { gql } from '@apollo/client'
import type { TypedDocumentNode } from '@apollo/client'

import type { LocationData } from '../getAttributesFromAccount'

export const LOCATION_DATA_QUERY: TypedDocumentNode<LocationData> = gql`
  query LocationDataQuery {
    location {
      country
    }
  }
`
